export const po_rules_based_configurator = 'qsp_rules_based_configurator'
export const global_rules_based_configurator = 'pdp_rules_based_configurator'
